// function uniAgeVerification(){

// }

function uniAgeVerification() {
  const styles = `
            @media (max-width: 768px) {
                .uni-modal-content {
                    margin-left: 10px; 
                    margin-right: 10px; 
                }
            }

            .uni-modal {
                font-family: Montserat, sans-serif;
                display: flex;
                justify-content: center;
                align-items: center;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                z-index: 999999;
            }
    
            .uni-modal-content {
                background: white;
                padding: 20px;
                border-radius: 8px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                max-width: 500px;
                text-align: center;
                position: relative;
                overflow: hidden;
            }
    
            .uni-modal-header {
                background-color: #ffcc00;
                color: #000000;
                font-size: 14px;
                font-weight: bold;
                text-transform: uppercase;
                width: 100%;
                height: 30px;
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }
    
            .uni-modal-content-inner {
                margin-top: 40px; /* Offset for the header */
            }
    
            .uni-logo-container {
                display: flex;
                justify-content: center;
                max-width: 200px;
                margin: 0 auto;
            }

            .uni-logo {
                width: 100%;
                height: auto;
            }
    
            .uni-button-container {
                display: flex;
                justify-content: space-around;
                margin-top: 15px;
                gap: 10px;
            }
    
            .uni-button-container button {
                background-color: #ffcc00;
                border: 1px solid #000000;
                border-radius: 5px;
                padding: 10px 20px;
                cursor: pointer;
                font-weight: bold;
                width:100%;
            }
    
            .uni-button-container button:hover {
                background-color: #ffffff;
            }
    
            .uni-button-container button:focus {
                outline: none;
            }

            .uni-button-container button.disagree {
                background-color: #ffffff;
                color: #000000;
            }

            .uni-button-container button.disagree:hover {
                background-color: #ffcc00;
                color: #000000;
            }
    
            .uni-modal-content p {
                color: #333;
                margin-bottom: 10px;
                line-height: 1.5;
            }
    
            .uni-modal-content strong {
                font-weight: bold;
            }
      `;

  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);

  function createAgeVerificationModal() {
    const modal = document.createElement("div");
    modal.id = "age-verification-modal";
    modal.classList.add("uni-modal");

    modal.innerHTML = `
          <div class="uni-modal-content">
            <div class="uni-modal-header">AGE VERIFICATION</div>
            <div class="uni-modal-content-inner">
            <div class="uni-logo-container">
                <img src="https://cdn.shopify.com/s/files/1/0570/3614/4848/files/ZiStock-LOGO-black-1_200x_82808f2e-7c91-4c01-8ae2-8cdfcfc20868.svg?v=1778262141" alt="ZiStock Logo" class="uni-logo">
            </div>
              <p>Please confirm that you are 21 years of age or older to proceed with this purchase. We perform age verification checks before processing any payments.</p>
              <div class="uni-button-container">
                <button id="agree" class="agree">Agree</button>
                <button id="disagree" class="disagree">Disagree</button>
              </div>
            </div>
          </div>
        `;

    document.body.appendChild(modal);

    const agreeButton = modal.querySelector("#agree");
    const disagreeButton = modal.querySelector("#disagree");

    agreeButton.addEventListener("click", function () {
      localStorage.setItem("uni-age-verified", "true");
      modal.style.display = "none";
    });

    disagreeButton.addEventListener("click", function () {
      window.location.href = "https://google.com/";
    });
  }

  function showAgeVerificationModal() {
    if (localStorage.getItem("uni-age-verified") !== "true") {
      if (!document.getElementById("age-verification-modal")) {
        createAgeVerificationModal();
      }

      document.getElementById("age-verification-modal").style.display = "flex";
    }
  }
  showAgeVerificationModal();
}
